import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetReplenishmentRulesQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.ReplenishmentRuleSummaryDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.ReplenishmentRuleSummaryDocumentSortInput> | Types.ReplenishmentRuleSummaryDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetReplenishmentRulesQuery = { __typename?: 'Query', replenishmentRules?: { __typename?: 'ReplenishmentRulesConnection', totalCount: number, nodes?: Array<{ __typename?: 'ReplenishmentRuleSummaryDocument', id: string, tenantId: string, ruleId: string, name: string, description: string, ruleType: Types.ReplenishmentRuleSummaryType, level: Types.ReserveRuleLevel, mode: Types.ReserveRuleMode, percentage: number, value: string, startDate?: Types.TDateISO | null, endDate?: Types.TDateISO | null, itemCount: number, locationCount: number, linkedItemIds: Array<string>, linkedLocationIds: Array<string>, status: Types.ReplenishmentRuleSummaryStatus, createdAt: Types.TDateISO, updatedAt: Types.TDateISO }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetReplenishmentRuleGroupsQueryVariables = Types.Exact<{
  groupBy: Types.ReplenishmentRuleGroupField;
  search?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetReplenishmentRuleGroupsQuery = { __typename?: 'Query', replenishmentRuleGroups: Array<{ __typename?: 'ReplenishmentRuleGroupBucket', key: string, label: string, count: number }> };

export type GetBlockingRuleQueryVariables = Types.Exact<{
  blockingRuleId: Types.Scalars['String']['input'];
}>;


export type GetBlockingRuleQuery = { __typename?: 'Query', blockingRule?: { __typename?: 'BlockingRuleStateData', tenantId: string, blockingRuleId: string, name: string, description: string, startDate?: Types.TDateISO | null, endDate?: Types.TDateISO | null, linkedItemIds: Array<string>, linkedLocationIds: Array<string>, status: Types.BlockingRuleStatus, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string } | null };

export type GetPromotionRuleQueryVariables = Types.Exact<{
  promotionRuleId: Types.Scalars['String']['input'];
}>;


export type GetPromotionRuleQuery = { __typename?: 'Query', promotionRule?: { __typename?: 'PromotionRuleStateData', tenantId: string, promotionRuleId: string, name: string, description: string, startDate: Types.TDateISO, endDate: Types.TDateISO, quantityFloor: number, linkedItemIds: Array<string>, linkedLocationIds: Array<string>, status: Types.PromotionRuleStatus, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string } | null };

export type ReplenishmentRuleSummaryFragment = { __typename?: 'ReplenishmentRuleSummaryDocument', id: string, tenantId: string, ruleId: string, name: string, description: string, ruleType: Types.ReplenishmentRuleSummaryType, level: Types.ReserveRuleLevel, mode: Types.ReserveRuleMode, percentage: number, value: string, startDate?: Types.TDateISO | null, endDate?: Types.TDateISO | null, itemCount: number, locationCount: number, linkedItemIds: Array<string>, linkedLocationIds: Array<string>, status: Types.ReplenishmentRuleSummaryStatus, createdAt: Types.TDateISO, updatedAt: Types.TDateISO };

export type PromotionRuleFieldsFragment = { __typename?: 'PromotionRuleStateData', tenantId: string, promotionRuleId: string, name: string, description: string, startDate: Types.TDateISO, endDate: Types.TDateISO, quantityFloor: number, linkedItemIds: Array<string>, linkedLocationIds: Array<string>, status: Types.PromotionRuleStatus, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string };

export type BlockingRuleFieldsFragment = { __typename?: 'BlockingRuleStateData', tenantId: string, blockingRuleId: string, name: string, description: string, startDate?: Types.TDateISO | null, endDate?: Types.TDateISO | null, linkedItemIds: Array<string>, linkedLocationIds: Array<string>, status: Types.BlockingRuleStatus, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string };

export const ReplenishmentRuleSummaryFragmentDoc = new TypedDocumentString(`
    fragment ReplenishmentRuleSummary on ReplenishmentRuleSummaryDocument {
  id
  tenantId
  ruleId
  name
  description
  ruleType
  level
  mode
  percentage
  value
  startDate
  endDate
  itemCount
  locationCount
  linkedItemIds
  linkedLocationIds
  status
  createdAt
  updatedAt
}
    `, {"fragmentName":"ReplenishmentRuleSummary"});
export const PromotionRuleFieldsFragmentDoc = new TypedDocumentString(`
    fragment PromotionRuleFields on PromotionRuleStateData {
  tenantId
  promotionRuleId
  name
  description
  startDate
  endDate
  quantityFloor
  linkedItemIds
  linkedLocationIds
  status
  createdAt
  createdBy
  updatedAt
  updatedBy
}
    `, {"fragmentName":"PromotionRuleFields"});
export const BlockingRuleFieldsFragmentDoc = new TypedDocumentString(`
    fragment BlockingRuleFields on BlockingRuleStateData {
  tenantId
  blockingRuleId
  name
  description
  startDate
  endDate
  linkedItemIds
  linkedLocationIds
  status
  createdAt
  createdBy
  updatedAt
  updatedBy
}
    `, {"fragmentName":"BlockingRuleFields"});
export const GetReplenishmentRulesDocument = new TypedDocumentString(`
    query GetReplenishmentRules($where: ReplenishmentRuleSummaryDocumentFilterInput, $order: [ReplenishmentRuleSummaryDocumentSortInput!], $first: Int, $after: String, $last: Int, $before: String) {
  replenishmentRules(
    where: $where
    order: $order
    first: $first
    after: $after
    last: $last
    before: $before
  ) {
    nodes {
      ...ReplenishmentRuleSummary
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment ReplenishmentRuleSummary on ReplenishmentRuleSummaryDocument {
  id
  tenantId
  ruleId
  name
  description
  ruleType
  level
  mode
  percentage
  value
  startDate
  endDate
  itemCount
  locationCount
  linkedItemIds
  linkedLocationIds
  status
  createdAt
  updatedAt
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetReplenishmentRuleGroupsDocument = new TypedDocumentString(`
    query GetReplenishmentRuleGroups($groupBy: ReplenishmentRuleGroupField!, $search: String) {
  replenishmentRuleGroups(groupBy: $groupBy, search: $search) {
    key
    label
    count
  }
}
    `);
export const GetBlockingRuleDocument = new TypedDocumentString(`
    query GetBlockingRule($blockingRuleId: String!) {
  blockingRule(blockingRuleId: $blockingRuleId) {
    ...BlockingRuleFields
  }
}
    fragment BlockingRuleFields on BlockingRuleStateData {
  tenantId
  blockingRuleId
  name
  description
  startDate
  endDate
  linkedItemIds
  linkedLocationIds
  status
  createdAt
  createdBy
  updatedAt
  updatedBy
}`);
export const GetPromotionRuleDocument = new TypedDocumentString(`
    query GetPromotionRule($promotionRuleId: String!) {
  promotionRule(promotionRuleId: $promotionRuleId) {
    ...PromotionRuleFields
  }
}
    fragment PromotionRuleFields on PromotionRuleStateData {
  tenantId
  promotionRuleId
  name
  description
  startDate
  endDate
  quantityFloor
  linkedItemIds
  linkedLocationIds
  status
  createdAt
  createdBy
  updatedAt
  updatedBy
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetReplenishmentRules: build.query<GetReplenishmentRulesQuery, GetReplenishmentRulesQueryVariables | void>({
      query: (variables) => ({ document: GetReplenishmentRulesDocument, variables })
    }),
    GetReplenishmentRuleGroups: build.query<GetReplenishmentRuleGroupsQuery, GetReplenishmentRuleGroupsQueryVariables>({
      query: (variables) => ({ document: GetReplenishmentRuleGroupsDocument, variables })
    }),
    GetBlockingRule: build.query<GetBlockingRuleQuery, GetBlockingRuleQueryVariables>({
      query: (variables) => ({ document: GetBlockingRuleDocument, variables })
    }),
    GetPromotionRule: build.query<GetPromotionRuleQuery, GetPromotionRuleQueryVariables>({
      query: (variables) => ({ document: GetPromotionRuleDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetReplenishmentRulesQuery, useLazyGetReplenishmentRulesQuery, useGetReplenishmentRuleGroupsQuery, useLazyGetReplenishmentRuleGroupsQuery, useGetBlockingRuleQuery, useLazyGetBlockingRuleQuery, useGetPromotionRuleQuery, useLazyGetPromotionRuleQuery } = injectedRtkApi;
